import { Order, OrderStatus } from '../../types/gqlTypes';

interface BuildOrdersData {
    ordersByEncryptedId: Record<string, Order>;
    deliveredOrder?: Order;
}

export const buildOrdersData = (orders: Order[]): BuildOrdersData => {
    const res = orders.reduce(
        (acc: BuildOrdersData, order: Order) => {
            acc.ordersByEncryptedId[order.encryptedId] = order;

            if (!acc.deliveredOrder && order.status === OrderStatus.Delivered) {
                acc.deliveredOrder = order;
            }

            return acc;
        },
        { ordersByEncryptedId: {}, deliveredOrder: undefined }
    );

    return res;
};
